const COUPON_SELECT_OPTIONS = [
  {
    label: '0枚 ',
    value: 0
  },
  {
    label: '1枚 ',
    value: 1
  },
  {
    label: '2枚',
    value: 2
  },
  {
    label: '3枚',
    value: 3
  },
  {
    label: '4枚',
    value: 4
  },
  {
    label: '5枚',
    value: 5
  },
  {
    label: '6枚',
    value: 6
  },
  {
    label: '7枚',
    value: 7
  },
  {
    label: '8枚',
    value: 8
  },
  {
    label: '9枚',
    value: 9
  },
  {
    label: '10枚',
    value: 10
  }
]

const COUPON_PRICE_TYPE = {
  OWNER: '本人',
  FAMILY: '家族',
  BOLT: '一律'
}

const COUPON_AGE_TYPE = {
  ADULT: '大人',
  CHILDREN: '子供',
  BOLT: '一律'
}


export {
  COUPON_SELECT_OPTIONS,
  COUPON_AGE_TYPE,
  COUPON_PRICE_TYPE
}